import { useQuery } from "@tanstack/react-query";
import { useSelector } from "../../../../../store/store";
import { PlanningDepartmentExportService } from "../../../../../services/planning-department/export-warehouse";

export const useGetMyApprovals = () => {
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const response = useQuery({
    queryKey: ["my-approvals-export", currentUserName],
    queryFn: () =>
      PlanningDepartmentExportService.getMyApproval({ email: currentUserName }),
      refetchOnMount:"always"
  });

  return response;
};
